import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useActiveResearches from '../features/activeResearch/useActiveResearches';

import ActionNotification from '../components/Assets/ActionNotification';
import Button from '../components/Assets/Button';
import SectionTitle from '../components/Assets/sectionTitle';

import { activeResearchActions } from '../features/activeResearch/activeResearchSlice';
import ActiveResearchResume from '../features/activeResearch/components/result/ActiveResearchResume';

import ActionButton from '../features/activeResearch/components/result/ActionButton';
import AdCardContainer from '../features/ad/components/adCardContainer/AdCardContainer';

import { isEmpty } from 'lodash';
import { useAppDispatch } from '../App/redux/store';
import useAds from '../features/ad/hooks/useAds';
import { loaderActions } from '../store/loader/actions';
import './styles/activeResearchResult.scss';

function ActiveResearchResultPage() {
  const { id } = useParams<{ id: string }>();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { currentActiveResearch, isCurrentActiveResearchLoading } =
    useActiveResearches({
      activeResearchId: id,
    });
  const {
    ads,
    adPagination,
    addItemToSelectedAd,
    loadActiveAd,
    selectedAds,
    handlePaginationChange,
  } = useAds({});

  useEffect(() => {
    return () => {
      dispatch(activeResearchActions.currentActiveResearchReset());
    };
  }, []);

  useEffect(() => {
    if (isCurrentActiveResearchLoading) {
      dispatch(loaderActions.loaderDisplay.visible());
    } else {
      dispatch(loaderActions.loaderDisplay.hidden());
    }
  }, [isCurrentActiveResearchLoading]);

  return (
    <main className="active-search-result">
      <ActionNotification />
      <header className="active-search-result-header">
        <div className="active-search-result-header-elt">
          <div className="active-search-result-ads">
            <span className="active-search-result-ads-nb">
              {adPagination.totalAds ?? 0}
            </span>
            <span>Annonces</span>
          </div>
          <SectionTitle
            mainTitle="Critères de recherche active"
            subTitle="Créez vos propres critères de recherches"
          />
        </div>
        <div className="active-search-result-header-elt">
          <ActionButton disabled={isEmpty(selectedAds)} />
          <Button
            btnType="button"
            btnContent="MODIFIER / AFFINER MES CRITERES"
            primary
            handleClick={() => navigate(`/recherche-active-modification/${id}`)}
          />

          <Button
            btnType="button"
            btnContent="PRÉCÉDENT"
            handleClick={() => navigate(`/recherches-actives`)}
            textColor="violet"
            bgColor="white"
            borderColor="grey"
          />
        </div>
      </header>

      <ActiveResearchResume currentActiveResearch={currentActiveResearch} />

      <AdCardContainer
        type="activeResearches"
        ads={ads}
        checkedIds={selectedAds.map((m) => m.idIri)}
        onPaginationChange={handlePaginationChange}
        onCheckAd={addItemToSelectedAd}
        onCardClick={loadActiveAd}
        adsPagination={adPagination}
      />
    </main>
  );
}

export default ActiveResearchResultPage;
